import carrots from "../assets/images/cart-images/carrots.png";
import cauliflower from "../assets/images/cart-images/cauliflower.png";
import cheddar from "../assets/images/cart-images/cheddar.png";
import chiaseeds from "../assets/images/cart-images/chia-seeds.png";
import chicken from "../assets/images/cart-images/chicken.png";
import chickpeas from "../assets/images/cart-images/chickpeas.png";
import collardgreens from "../assets/images/cart-images/collard-greens.png";
import cornoil from "../assets/images/cart-images/corn-oil.png";
import cottagecheese from "../assets/images/cart-images/cottage-cheese.png";
import cowmilk from "../assets/images/cart-images/cow-milk.png";
import edamame from "../assets/images/cart-images/edamame.png";
import eggs from "../assets/images/cart-images/eggs.png";
import farro from "../assets/images/cart-images/farro.png";
import feta from "../assets/images/cart-images/feta.png";
import fish from "../assets/images/cart-images/fish.png";
import flaxseedoil from "../assets/images/cart-images/flaxseed-oil.png";
import flaxseeds from "../assets/images/cart-images/flaxseeds.png";
import goatmilk from "../assets/images/cart-images/goat-milk.png";
import grapefruits from "../assets/images/cart-images/grapefruits.png";
import greekyogurt from "../assets/images/cart-images/greek-yogurt.png";
import guavas from "../assets/images/cart-images/guavas.png";
import kale from "../assets/images/cart-images/kale.png";
import kefir from "../assets/images/cart-images/kefir.png";
import lemons from "../assets/images/cart-images/lemons.png";
import lentils from "../assets/images/cart-images/lentils.png";
import lettuce from "../assets/images/cart-images/lettuce.png";
import limes from "../assets/images/cart-images/limes.png";
import mackerel from "../assets/images/cart-images/mackerel.png";
import mangoes from "../assets/images/cart-images/mangoes.png";
import millet from "../assets/images/cart-images/millet.png";
import mozzarella from "../assets/images/cart-images/mozzarella.png";
import oatmilk from "../assets/images/cart-images/oat-milk.png";
import oats from "../assets/images/cart-images/oats.png";
import oliveoil from "../assets/images/cart-images/olive-oil.png";
import oranges from "../assets/images/cart-images/oranges.png";
import papayas from "../assets/images/cart-images/papayas.png";
import peanutbutter from "../assets/images/cart-images/peanut-butter.png";
import peanutoil from "../assets/images/cart-images/peanut-oil.png";
import peanuts from "../assets/images/cart-images/peanuts.png";
import peas from "../assets/images/cart-images/peas.png";
import pecans from "../assets/images/cart-images/pecans.png";
import pineapples from "../assets/images/cart-images/pineapples.png";
import pork from "../assets/images/cart-images/pork.png";
import pumpkinseeds from "../assets/images/cart-images/pumpkin-seeds.png";
import quinoa from "../assets/images/cart-images/quinoa.png";
import radishes from "../assets/images/cart-images/radishes.png";
import raspberries from "../assets/images/cart-images/raspberries.png";
import saffloweroil from "../assets/images/cart-images/safflower-oil.png";
import salmon from "../assets/images/cart-images/salmon.png";
import sardines from "../assets/images/cart-images/sardines.png";
import sesameseeds from "../assets/images/cart-images/sesame-seeds.png";
import skyr from "../assets/images/cart-images/skyr.png";
import soybeanoil from "../assets/images/cart-images/soybean-oil.png";
import soymilk from "../assets/images/cart-images/soy-milk.png";
import spinach from "../assets/images/cart-images/spinach.png";
import sproutedbarley from "../assets/images/cart-images/sprouted-barley.png";
import sproutedbrownrice from "../assets/images/cart-images/sprouted-brown-rice.png";
import sproutedwheat from "../assets/images/cart-images/sprouted-wheat.png";
import strawberries from "../assets/images/cart-images/strawberries.png";
import sunfloweroil from "../assets/images/cart-images/sunflower-oil.png";
import sunflowerseeds from "../assets/images/cart-images/sunflower-seeds.png";
import sweetpotatoes from "../assets/images/cart-images/sweet-potatoes.png";
import swisschard from "../assets/images/cart-images/swiss-chard.png";
import tahini from "../assets/images/cart-images/tahini.png";
import teff from "../assets/images/cart-images/teff.png";
import tempeh from "../assets/images/cart-images/tempeh.png";
import tofu from "../assets/images/cart-images/tofu.png";
import turkey from "../assets/images/cart-images/turkey.png";
import turnips from "../assets/images/cart-images/turnips.png";
import walnuts from "../assets/images/cart-images/walnuts.png";
import wholewheat from "../assets/images/cart-images/whole-wheat.png";
import yogurt from "../assets/images/cart-images/yogurt.png";
import almondmilk from "../assets/images/cart-images/almond-milk.png";
import almonds from "../assets/images/cart-images/almonds.png";
import amaranth from "../assets/images/cart-images/amaranth.png";
import arugula from "../assets/images/cart-images/arugula.png";
import avocados from "../assets/images/cart-images/avocados.png";
import barley from "../assets/images/cart-images/barley.png";
import beans from "../assets/images/cart-images/beans.png";
import beef from "../assets/images/cart-images/beef.png";
import beets from "../assets/images/cart-images/beets.png";
import blackberries from "../assets/images/cart-images/blackberries.png";
import blueberries from "../assets/images/cart-images/blueberries.png";
import broccoli from "../assets/images/cart-images/broccoli.png";
import brownrice from "../assets/images/cart-images/brown-rice.png";
import brusselssprouts from "../assets/images/cart-images/brussels-sprouts.png";
import cabbage from "../assets/images/cart-images/cabbage.png";
import canolaoil from "../assets/images/cart-images/canola-oil.png";

export const cartExampleImages = {
  carrots,
  cauliflower,
  cheddar,
  chiaseeds,
  chicken,
  chickpeas,
  collardgreens,
  cornoil,
  cottagecheese,
  cowmilk,
  edamame,
  eggs,
  farro,
  feta,
  fish,
  flaxseedoil,
  flaxseeds,
  goatmilk,
  grapefruits,
  greekyogurt,
  guavas,
  kale,
  kefir,
  lemons,
  lentils,
  lettuce,
  limes,
  mackerel,
  mangoes,
  millet,
  mozzarella,
  oatmilk,
  oats,
  oliveoil,
  oranges,
  papayas,
  peanutbutter,
  peanutoil,
  peanuts,
  peas,
  pecans,
  pineapples,
  pork,
  pumpkinseeds,
  quinoa,
  radishes,
  raspberries,
  saffloweroil,
  salmon,
  sardines,
  sesameseeds,
  skyr,
  soybeanoil,
  soymilk,
  spinach,
  sproutedbarley,
  sproutedbrownrice,
  sproutedwheat,
  strawberries,
  sunfloweroil,
  sunflowerseeds,
  sweetpotatoes,
  swisschard,
  tahini,
  teff,
  tempeh,
  tofu,
  turkey,
  turnips,
  walnuts,
  wholewheat,
  yogurt,
  almondmilk,
  almonds,
  amaranth,
  arugula,
  avocados,
  barley,
  beans,
  beef,
  beets,
  blackberries,
  blueberries,
  broccoli,
  brownrice,
  brusselssprouts,
  cabbage,
  canolaoil,
};
